/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ allocated: NonNullable<unknown>, remaining: NonNullable<unknown> }} Deal_Splits_ProgressInputs */

const cs_deal_splits_progress = /** @type {(inputs: Deal_Splits_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Přiděleno ${i?.allocated} % · zbývá ${i?.remaining} %`)
};

const en_deal_splits_progress = /** @type {(inputs: Deal_Splits_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.allocated}% allocated · ${i?.remaining}% remaining`)
};

/**
* | output |
* | --- |
* | "{allocated}% allocated · {remaining}% remaining" |
*
* @param {Deal_Splits_ProgressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_progress = /** @type {((inputs: Deal_Splits_ProgressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_ProgressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_progress(inputs)
	return cs_deal_splits_progress(inputs)
});